export const mockedData= [
    {
        response1: `Hey, Andrew. Yes I can help you get started with stocks and research their financial data. Ask any question and Ill help you with a solution.`,
        response2: `But first, I need to ask you a couple of questions to understand more about you and your skills in finance and securities investing`,
    },
    {
        response1: `Next questions to understand more about you and your skills in finance and securities investing`,
        answerInput: [
            `Yes, some longer answer`,
            `No, some longer answer`,
            `Maybe, some longer answer`,
        ],
    },
    {
        response1:` Next questions to understand more about you and your skills in finance and securities investing`,
        answerInput: [
            `Yes, some longer answer`,
            `No, some longer answer`,
            `Maybe, some longer answer`,
        ],
    },
];

export const loading = `I'm gathering data...`;

export const DISCLAIMER_TEXT = [
    'The Platform and the Services are provided for informational or research purposes only and should NOT be relied upon to make investment decisions considered as professional investment advice.',
    'We expressly waive any responsibility for any losses resulting from errors in data or analysis displayed in the Platform or the Services.',
    '\n','\n','The analysis and any Services provided in or through the Platform is not investment advice and should not be construed as investment advice. The analysis provided by the Platform should never be the sole or main form of analysis you perform before making investment decisions.',
    '\n','\n','ALL ANALYSIS AND ANY SERVICES PROVIDED IN OR THROUGH THE PLATFORM, ARE PROVIDED ON AN AS-IS BASIS AND IS NOT GUARANTEED TO BE TRUE, ACCURATE OR CORRECT AND YOU SHOULD NEVER MAKE INVESTMENT IN RELIANCE SOLELY ON SUCH ANALYSIS AND/OR SERVICE.',
    '\n','\n','Without derogating from the generality of the foregoing, you assume all risks associated with investment decisions that you decide to make based on the information you find inside the Platform or as part of the Services.',
    'You represent that you understand that we depend on potentially inaccurate third-party information and unproven formulas and mathematical sequences and thus cannot be depended on to provide accurate investment advice.',
    'Before executing any trade, it is recommended to consult with a registered and licensed professional and/or conduct your own extensive due diligence utilizing multiple sources of information.',
    'We will not be responsible if you do not heed this warning and make investment decisions based solely or mainly on information from the Platform and/or the Services.'];

export const deviceType = {
    mobile: 'mobile',
    tablet: 'tablet',
    desktop: 'desktop',
};

export const colorKeys = [
  ["--colorTheme", "color_theme"],
  ["--overlayClr", "overlay_clr"],
  ["--overlayMenuBackgroundClr", "overlay_menu_background_clr"],
  ["--backgroundClr1", "background_clr1"],
  ["--backgroundClr2", "background_clr2"],
  ["--backgroundClr3", "background_clr3"],
  ["--mainBtnClr1", "main_btn_clr1"],
  ["--mainBtnClr2", "main_btn_clr2"],
  ["--mainBtnClr3", "main_btn_clr3"],
  ["--mainBtnClr4", "main_btn_clr4"],
  ["--mainBtnClr5", "main_btn_clr5"],
  ["--mainBtnShadowClr", "main_btn_shadow_clr"],
  ["--secondaryBtnClr", "secondary_btn_clr"],
  ["--markedFollowupBtnClr", "marked_followup_btn_clr"],
  ["--tooltipBackgroundClr", "tool_tip_background_clr"],
  ["--normalTextClr", "normal_text_clr"],
  ["--ellipseTop", "ellipse_top"],
  ["--ellipseBottom", "ellipse_bottom"],
  ["--arrowBackgroundClr", "arrow_background_clr"],
  ["--colorfulTextClr1", "colorful_text_clr1"],
  ["--colorfulTextClr2", "colorful_text_clr2"],
  ["--colorfulTextClr3", "colorful_text_clr3"],
  ["--negativeClr", "negative_clr"],
  ["--positiveClr", "positive_clr"],
  ["--transparentWClr", "transparent_wclr"],
  ["--markdownBackgroundClr", "markdown_background_clr"],
  ["--markdownBackgroundClr1", "markdown_background_clr1"],
  ["--markdownBackgroundClr2", "markdown_background_clr2"],
  ["--markdownBackgroundClr3", "markdown_background_clr3"],
  ["--markdownBorderClr", "markdown_border_clr"],
  ["--markdownTextClr1", "markdown_text_clr1"],
  ["--markdownTextClr2", "markdown_text_clr2"],
  ["--markdownTextClr3", "markdown_text_clr3"],
  ["--markdownTextClr4", "markdown_text_clr4"],
  ["--markdownTextClr5", "markdown_text_clr5"],
  ["--markdownTextClr6", "markdown_text_clr6"],
  ["--markdownTextClr7", "markdown_text_clr7"],
  ["--boxShadowClr1", "box_shadow_Clr1"],
  ["--boxShadowClr2", "box_shadow_Clr2"],
  ["--textBorderClr1", "text_border_clr1"],
  ["--textBorderClr2", "text_border_clr2"],
  ["--textShadowClr", "text_shadow_clr"],
  ["--questBackgroundClr1", "quest_background_clr1"],
  ["--questBackgroundClr2", "quest_background_clr2"],
  ["--userBackgroundClr", "user_background_clr"],
  ["--userShadowClr1", "user_shadow_clr1"],
  ["--userShadowClr2", "user_shadow_clr2"],
  ["--questionBtnBorderClr1", "question_btn_border_clr1"],
  ["--questionBtnBorderClr2", "question_btn_border_clr2"],
  ["--checkedBorderClr1", "checked_border_clr1"],
  ["--checkedBorderClr2", "checked_border_clr2"],
  ["--checkedShadowClr", "checked_shadow_clr"],
  ["--codeBlockBackgroundClr", "codeBlock_background_clr"],
  ["--newChatBtnClr", "newchat_btn_clr"],
  ["--sendButtonClr", "send_button_clr"],
  ["--stopButtonClr", "stop_button_clr"],
  ["--iconsBackgroundClr", "icons_background_clr"],
  ["--errorBackgroundClr", "error_background_clr"],
  ["--errorShadowClr", "error_shadow_clr"],
  ["--errorClr", "error_clr"],
  ["--disclaimerBackgroundClr", "disclaimer_background_clr"],
  ["--disclaimerTextClr", "disclaimer_text_clr"],
  ["--initQuestTextClr", "init_quest_text_clr"],
  ["--questTextClr", "quest_text_clr"],
  ["--shineVerboseEffectClr", "shine_verbose_effect_clr"],
];

 export const SkillClients = ["TRADINGMOON", "SKILLING"];